import React from 'react';
import tw, { styled } from 'twin.macro';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Button } from '@sopranodesign/pulse-components';

import { useBot } from '../../../hooks/index';

const ModalButton = styled(
  (
    {
      icon = 'arrowsExpand',
      colour = 'white',
      ...props
    }
  ) => <Button icon={icon} colour={colour} {...props} />
)`
  ${tw`p-0 h-auto w-auto border-none bg-transparent relative cursor-pointer rounded flex`}
  border: 1px solid transparent;
  i {
    ${tw`w-4 h-4`};
  }
  svg {
    ${tw`opacity-75 w-4 h-4`};
  }
  &:not(:disabled):hover {
    ${tw`bg-transparent`};
  }
  &:hover svg {
    ${tw`opacity-100`};
  }
  > * {
    pointer-events: none;
  }
`;

const IframeModalButton = ({ content, ...props }) => {
  const { setIframeModal, onIframeModalOpen } = useBot();
  const { t } = useTranslation(['bots', 'converse']);

  return (
    <ModalButton
      {...props}
      aria-label={t('open_widget_button_label', { ns: 'converse' })}
      onClick={() => {
        setIframeModal({
          type: 'content',
          value: content
        });
        onIframeModalOpen('open');
      }}
    />
  );
};

IframeModalButton.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string
  })
};

export default IframeModalButton;
